export function isNull(value) {
  return typeof value === "undefined" || value === null
}
